import { PermissionId, workspacesConfig } from 'utils/powerLevelsConfig';

/**
 * Scope-aware cascade: mutates `permissions` so that the lock ladder is correct
 * for the scope of `targetPermissionId`. Other scopes are untouched.
 *
 * - `isEnabling === true`  → every same-scope permission with `powerLevel <= targetPL`
 *   is forced to `true` (the V2 lock cascade — a checked higher-PL permission
 *   implies every lower-PL permission in the same scope).
 * - `isEnabling === false` → every same-scope permission with `powerLevel >= targetPL`
 *   is forced to `false`. Restoration of strictly-lower-PL permissions from
 *   pre-lock shadow state is the orchestrating hook's responsibility
 *   (see `usePermissionField`).
 */
export const cascadePermissionSelections = (
  permissions: Record<PermissionId, boolean>,
  targetPermissionId: PermissionId,
  isEnabling: boolean
) => {
  const targetEntry = workspacesConfig[targetPermissionId];
  if (!targetEntry) return;

  Object.values(PermissionId).forEach((id) => {
    const entry = workspacesConfig[id];
    if (!entry || entry.scope !== targetEntry.scope) return;

    if (isEnabling && entry.powerLevel <= targetEntry.powerLevel) {
      permissions[id] = true;
    } else if (!isEnabling) {
      permissions[id] = false;
    }
  });
};
